var map = {
	"./anm-card.png": 1190,
	"./arrow.png": 1191,
	"./arrow.webp": 1192,
	"./asset-1.svg": 1193,
	"./bg-exclusive.webp": 1194,
	"./boost.svg": 1195,
	"./brand-logo-cny.png": 1196,
	"./brand-logo-raya.webp": 1197,
	"./brand-logo.png": 110,
	"./brand-logo.webp": 1198,
	"./btn-black-m.webp": 1199,
	"./btn-blue-m-v2.png": 1200,
	"./btn-blue-m.png": 1201,
	"./btn-blue-m.webp": 1202,
	"./btn-white-m-v2.png": 1203,
	"./btn-white-m.png": 1204,
	"./check-btn.webp": 1205,
	"./default-bg.webp": 1206,
	"./deposit.webp": 1207,
	"./drop-more-btn.webp": 1208,
	"./duitnow.svg": 1209,
	"./eeziepay.svg": 1210,
	"./fcl.svg": 1211,
	"./fcl.webp": 1212,
	"./fpx-logo.svg": 1213,
	"./game-blue.png": 1214,
	"./game-img.png": 1215,
	"./game-white.png": 1216,
	"./global-language.svg": 1217,
	"./grabpay.svg": 1218,
	"./ifm-logo.svg": 1219,
	"./ifm-logo.webp": 1220,
	"./modal-bg.jpg": 1221,
	"./number-bg.webp": 1222,
	"./pagcor.svg": 1223,
	"./pagcor.webp": 1224,
	"./pool-bg.webp": 1225,
	"./promo-given.webp": 1226,
	"./side-bar-bg.png": 1227,
	"./spotlight-base.svg": 1228,
	"./spotlight.svg": 1229,
	"./tether.svg": 1230,
	"./title-asset.svg": 1231,
	"./tng.svg": 1232,
	"./winner.webp": 1233,
	"./withdrawal.webp": 1234
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 169;